import { render, staticRenderFns } from "./StudentNavigation.vue?vue&type=template&id=33e5967e&scoped=true&"
import script from "./StudentNavigation.vue?vue&type=script&lang=js&"
export * from "./StudentNavigation.vue?vue&type=script&lang=js&"
import style0 from "./StudentNavigation.vue?vue&type=style&index=0&id=33e5967e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e5967e",
  null
  
)

export default component.exports